import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState("light"); // default theme

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  const themePreference = (newTheme) => {
    setTheme(newTheme ? newTheme : "light") 
  }
  // sets the data-theme on <body> whenever theme changes
  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, themePreference }}>
      {children}
    </ThemeContext.Provider>
  );
}
